{
  "title": "Управление коннекторами",
  "refresh": "Обновить",
  "save": "Сохранить",
  "cancel": "Отмена",
  "saving": "Сохранение",
  "error": "Произошла ошибка",
  "index": "№",
  "every": "каждые {{value}}",
  "seconds_one": "{{count}} секунду",
  "seconds_few": "{{count}} секунды",
  "seconds_many": "{{count}} секунд",
  "seconds_other": "{{count}} секунды",
  "minutes_one": "{{count}} минуту",
  "minutes_few": "{{count}} минуты",
  "minutes_many": "{{count}} минут",
  "minutes_other": "{{count}} минуты",
  "status": {
    "ok": "Работает",
    "error": "Ошибка",
    "off": "Выключен"
  },
  "ws": {
    "idle": "Ожидание",
    "connecting": "Подключение",
    "open": "Подключено",
    "reconnecting": "Переподключение"
  },
  "source": {
    "title": "Источник данных в реальном времени",
    "desc": "Откуда поступают значения показателей и состояние источника",
    "name": "Источник",
    "mock": "Симулятор (тестовые данные)",
    "unified": "Единый сервер ATNT",
    "state": "Состояние",
    "lastSuccess": "Последний успешный запрос",
    "interval": "Интервал опроса",
    "bound": "Привязанные показатели",
    "boundValue": "{{bound}} / {{total}}",
    "browser": "Связь браузера",
    "notConfigured": "Для LIVE_SOURCE=unified не заданы UNIFIED_BASE_URL и UNIFIED_API_KEY — значения офлайн."
  },
  "site": {
    "title": "Сайт единого сервера",
    "desc": "Код водохранилища на едином сервере",
    "label": "Код сайта",
    "placeholder": "Например: chotqol",
    "empty": "Код сайта не задан",
    "orgOnly": "Код сайта может менять только администратор организации",
    "invalid": "Только строчные латинские буквы, цифры, «-» и «_»",
    "saved": "Код сайта сохранён"
  },
  "channels": {
    "title": "Каналы показателей",
    "desc": "Привяжите физический показатель к каналу единого сервера: выберите или введите канал и нажмите Enter.",
    "readOnly": "Для изменения каналов нужен доступ на редактирование «Коннекторов».",
    "search": "Поиск по устройству или показателю",
    "device": "Устройство",
    "indicator": "Показатель",
    "channel": "Канал",
    "binding": "Привязка",
    "value": "Последнее значение",
    "time": "Время измерения",
    "status": "Статус",
    "none": "Не привязан",
    "bound": "Привязан",
    "unknown": "Неизвестный канал",
    "placeholder": "Выберите канал",
    "saved": "Канал сохранён",
    "empty": "Физических показателей нет"
  },
  "help": {
    "title": "Как это работает?",
    "items": [
      "Единый сервер по CSV-файлам агентов на водохранилищах рассчитывает для каждого сайта 4 показателя: LEVEL (уровень), VOLUME (объём), INFLOW (приток) и DISCHARGE (сброс).",
      "Чтобы подключить водохранилище, укажите код его сайта (например, chotqol) и выберите каналы для физических показателей: hydro:LEVEL, hydro:VOLUME, hydro:INFLOW или hydro:DISCHARGE.",
      "Данные на сервере обновляются раз в час, коннектор опрашивает его каждые 5 минут. Значение старше 3 часов показывается как «Нет данных».",
      "Принимаются только значения со статусом «ok»; в остальных случаях показатель офлайн и критерии не проверяются."
    ]
  },
  "statuses": {
    "connected": "Подключён",
    "error": "Ошибка",
    "disabled": "Выключен",
    "checking": "Проверка"
  },
  "scopes": {
    "organization": "Организация",
    "tenant": "Водохранилище"
  },
  "time": {
    "never": "Ещё не было",
    "justNow": "Только что",
    "minutes_one": "{{count}} минуту назад",
    "minutes_few": "{{count}} минуты назад",
    "minutes_many": "{{count}} минут назад",
    "minutes_other": "{{count}} минуты назад",
    "hours_one": "{{count}} час назад",
    "hours_few": "{{count}} часа назад",
    "hours_many": "{{count}} часов назад",
    "hours_other": "{{count}} часа назад",
    "days_one": "{{count}} день назад",
    "days_few": "{{count}} дня назад",
    "days_many": "{{count}} дней назад",
    "days_other": "{{count}} дня назад"
  },
  "types": {
    "atnt_unified": {
      "name": "Единый сервер ATNT",
      "desc": "Датчики и гидропоказатели 6 водохранилищ на одном сервере",
      "help": "Единый сервер отдаёт последнее значение каждого датчика из CSV-файлов, которые присылают агенты водохранилищ, и 4 гидропоказателя."
    },
    "rest": {
      "name": "REST API",
      "desc": "Опрос списка датчиков и значений из вашего бэкенда по HTTP",
      "help": "Коннектор с заданным интервалом запрашивает каталог датчиков и последние значения через HTTP GET. Поля JSONPath указывают идентификатор, значение и время в ответе."
    },
    "mqtt": {
      "name": "MQTT-брокер",
      "desc": "Приём сообщений датчиков из топиков MQTT в реальном времени",
      "help": "Коннектор подписывается на брокер; каждый топик, подходящий под фильтр, становится отдельным датчиком (JSON, CSV или число)."
    },
    "opcua": {
      "name": "OPC UA",
      "desc": "Чтение узлов OPC UA систем SCADA и ПЛК",
      "help": "Коннектор подключается к серверу OPC UA и с заданным интервалом читает указанные узлы (NodeId). Каждый узел — один датчик."
    },
    "modbus_tcp": {
      "name": "Modbus TCP",
      "desc": "Опрос регистров контроллеров по Modbus TCP",
      "help": "Коннектор читает регистры из списка с устройства Modbus TCP (IP, порт, unit ID) и применяет коэффициент масштаба. Каждый регистр — один датчик."
    },
    "webhook": {
      "name": "Вебхук",
      "desc": "Внешняя система сама отправляет данные (HTTP POST)",
      "help": "Внешняя система отправляет значения POST-запросом на указанный URL и подписывает каждый запрос секретом (X-Signature, HMAC-SHA256). Датчики появятся с первыми данными."
    },
    "file_import": {
      "name": "Импорт файлов (CSV / Excel)",
      "desc": "Загрузка файлов логгеров вручную или по расписанию",
      "help": "Каждый загруженный файл читается по карте столбцов: столбец времени и по одному датчику на каждый столбец данных."
    }
  },
  "list": {
    "title": "Коннекторы",
    "create": "Добавить коннектор",
    "search": "Поиск по названию, типу или адресу",
    "typeFilter": "Фильтр по типу",
    "allTypes": "Все типы",
    "statusFilter": "Фильтр по статусу",
    "allStatuses": "Все статусы",
    "name": "Коннектор",
    "type": "Тип",
    "scope": "Область",
    "status": "Статус",
    "sensors": "Датчики",
    "lastSync": "Последняя синхронизация",
    "empty": "Коннекторов пока нет",
    "emptyHint": "Подключите источник, из которого приходят датчики и их значения."
  },
  "table": {
    "actions": "Действие",
    "actionsLabel": "Действия"
  },
  "menu": {
    "open": "Открыть",
    "test": "Проверить",
    "enable": "Включить",
    "disable": "Выключить",
    "edit": "Редактировать",
    "delete": "Удалить",
    "enabled": "Коннектор включён",
    "disabled": "Коннектор выключен",
    "deleteTitle": "Удалить коннектор",
    "deleteText": "Коннектор «{{name}}» будет удалён. Привязанные показатели перестанут получать значения.",
    "deleteOrgText": "Коннектор организации «{{name}}» будет удалён для всех водохранилищ. Привязанные показатели перестанут получать значения.",
    "deleted": "Коннектор удалён"
  },
  "test": {
    "run": "Проверить подключение",
    "running": "Проверка…",
    "ok": "Подключение успешно",
    "failed": "Не удалось подключиться",
    "latency": "{{ms}} мс",
    "sensors_one": "найден {{count}} датчик",
    "sensors_few": "найдено {{count}} датчика",
    "sensors_many": "найдено {{count}} датчиков",
    "sensors_other": "найдено {{count}} датчика"
  },
  "panel": {
    "back": "Назад",
    "createTitle": "Добавить коннектор",
    "editTitle": "Редактировать коннектор",
    "stepType": "Тип источника",
    "stepSettings": "Настройки",
    "pickHint": "Выберите, откуда приходят датчики.",
    "changeType": "Сменить тип",
    "connected": "Подключён",
    "soon": "Скоро",
    "saved": "Изменения сохранены",
    "created": "Коннектор добавлен"
  },
  "common": {
    "unsavedTitle": "Изменения не сохранены",
    "unsavedText": "Введённые данные будут потеряны.",
    "stay": "Остаться",
    "leave": "Выйти"
  },
  "form": {
    "name": "Название коннектора",
    "namePlaceholder": "Например: телеметрия подрядчика",
    "description": "Описание",
    "descriptionPlaceholder": "Краткое примечание (необязательно)",
    "scope": "Область",
    "scopeHint": "Коннектор организации виден во всех водохранилищах организации.",
    "scopeOrgOnly": "Коннектор организации может добавить только администратор организации.",
    "scopeFixed": "Область нельзя изменить после создания.",
    "connection": "Подключение",
    "enabled": "Коннектор включён",
    "pollInterval": "Интервал опроса",
    "pollHint": "От 10 секунд до 24 часов",
    "sec": "сек",
    "secretStored": "Сохранено: {{hint}} — введите новое значение для замены",
    "secretPlaceholder": "Введите секретное значение",
    "show": "Показать",
    "hide": "Скрыть",
    "copy": "Копировать",
    "copied": "Скопировано",
    "copyFailed": "Не удалось скопировать",
    "regenerate": "Сгенерировать новый секрет",
    "baseUrl": "Адрес сервера (URL)",
    "baseUrlHint": "С префиксом /api, например https://monitoring.uzgidro.uz/api",
    "apiKey": "API-ключ (X-API-Key)",
    "apiKeyHint": "Выдаётся в едином сервере в разделе «Ключи внешних систем»; показывается один раз.",
    "siteCode": "Код площадки",
    "siteCodeHint": "Свой для каждого водохранилища — меняется на карточке «Площадка единого сервера».",
    "siteCodeEmpty": "Не задан",
    "auth": "Аутентификация",
    "authKinds": {
      "none": "Нет",
      "header": "Ключ в заголовке",
      "bearer": "Bearer-токен"
    },
    "headerName": "Имя заголовка",
    "headerValue": "Значение ключа",
    "token": "Токен",
    "sensorsPath": "Путь датчиков",
    "valuesPath": "Путь значений",
    "idPath": "ID (JSONPath)",
    "valuePath": "Значение (JSONPath)",
    "timePath": "Время (JSONPath)",
    "brokerUrl": "Адрес брокера",
    "brokerHint": "mqtt://, mqtts://, ws:// или wss://",
    "topic": "Фильтр топиков",
    "topicHint": "+ — один уровень, # — все оставшиеся уровни",
    "username": "Пользователь",
    "password": "Пароль",
    "payloadFormat": "Формат сообщения",
    "endpointUrl": "Адрес endpoint",
    "securityMode": "Режим безопасности",
    "security": {
      "none": "Нет (None)",
      "sign": "Подпись (Sign)",
      "sign_encrypt": "Подпись и шифрование"
    },
    "nodeIds": "Узлы (NodeId)",
    "nodeIdsHint": "По одному NodeId в строке",
    "host": "Хост (IP или имя)",
    "port": "Порт",
    "unitId": "Unit ID",
    "registers": "Регистры",
    "addRegister": "Добавить регистр",
    "registerName": "Название регистра",
    "address": "Адрес",
    "removeRegister": "Удалить регистр",
    "registerKind": "Тип регистра",
    "registerKinds": {
      "holding": "Holding",
      "input": "Input",
      "coil": "Coil",
      "discrete": "Discrete"
    },
    "dataType": "Тип данных",
    "scale": "Масштаб",
    "unit": "Ед.",
    "webhookUrl": "Адрес вебхука",
    "webhookUrlHint": "Внешняя система отправляет значения POST-запросом на этот адрес.",
    "webhookSecret": "Секрет",
    "webhookSecretOnce": "Скопируйте секрет сейчас — после сохранения он не показывается полностью.",
    "webhookSecretHint": "Секрет сохранён. Новый заменит его после сохранения.",
    "fileFormat": "Формат файла",
    "delimiter": "Разделитель",
    "delimiters": {
      "comma": "Запятая ( , )",
      "semicolon": "Точка с запятой ( ; )",
      "tab": "Табуляция"
    },
    "timeColumn": "Столбец времени",
    "timeFormat": "Формат времени",
    "headerRow": "Строка заголовка",
    "decimal": "Десятичный разделитель",
    "columns": "Столбцы данных",
    "columnsHint": "По одному столбцу в строке: «Название столбца | единица»"
  },
  "errors": {
    "required": "Обязательное поле",
    "url": "Введите корректный адрес",
    "interval": "Целое число от 10 до 86400",
    "header": "Только латиница, цифры и «-»",
    "path": "Путь, начинающийся с «/»",
    "jsonPath": "JSONPath, начинающийся с «$»",
    "host": "IP-адрес или имя хоста",
    "port": "От 1 до 65535",
    "unitId": "От 0 до 255",
    "nodeIds": "Укажите хотя бы один NodeId",
    "columns": "Укажите хотя бы один столбец",
    "registers": "Нужен хотя бы один регистр",
    "number": "Целое положительное число",
    "secret": "Введите секретное значение",
    "address": "0–65535",
    "invalid": "Неверное значение"
  },
  "detail": {
    "notFound": "Коннектор не найден",
    "notFoundHint": "Он удалён или у вас нет к нему доступа.",
    "back": "К коннекторам",
    "tabsLabel": "Разделы коннектора",
    "tabs": {
      "overview": "Обзор",
      "sensors": "Датчики",
      "channels": "Каналы",
      "settings": "Настройки",
      "log": "Журнал"
    }
  },
  "overview": {
    "status": "Состояние",
    "statusDesc": "Подключение к источнику и последняя синхронизация",
    "state": "Статус",
    "lastSync": "Последняя синхронизация",
    "interval": "Интервал опроса",
    "push": "Источник присылает сам",
    "bound": "Привязанные датчики",
    "enabled": "Включён",
    "yes": "Да",
    "no": "Нет",
    "type": "Тип",
    "notSet": "Не задан",
    "createdAt": "Создан",
    "createdBy": "Добавил",
    "system": "Система",
    "source": "Источник",
    "sourceDesc": "Откуда и как берутся данные",
    "nodes": "Датчики по узлам",
    "nodesDesc_one": "{{count}} узел (устройство / шлюз) · привязано / всего",
    "nodesDesc_few": "{{count}} узла (устройства / шлюзы) · привязано / всего",
    "nodesDesc_many": "{{count}} узлов (устройств / шлюзов) · привязано / всего",
    "nodesDesc_other": "{{count}} узла · привязано / всего",
    "all": "Все",
    "recent": "Последние события",
    "recentDesc": "Синхронизации, проверки и изменения"
  },
  "sensors": {
    "hydroNode": "Вычисляемые гидропоказатели",
    "empty": "Датчики пока не найдены",
    "emptyHint": "Датчики появятся здесь, когда от источника придут первые данные.",
    "search": "Поиск по столбцу, узлу или показателю",
    "filter": "Фильтр по привязке",
    "all": "Все",
    "bound": "Привязанные",
    "unbound": "Непривязанные",
    "column": "Датчик (столбец)",
    "channel": "Канал",
    "value": "Последнее значение",
    "time": "Время измерения",
    "binding": "Привязанный показатель",
    "notBound": "Не привязан",
    "bindPlaceholder": "Выберите показатель",
    "unbind": "Отвязать",
    "boundToast": "Датчик привязан",
    "unboundToast": "Привязка снята",
    "import": "Импортировать как устройства",
    "importN_one": "Импортировать как устройства ({{count}})",
    "importN_few": "Импортировать как устройства ({{count}})",
    "importN_many": "Импортировать как устройства ({{count}})",
    "importN_other": "Импортировать как устройства ({{count}})",
    "imported_one": "Импортировано устройств: {{devices}}, показателей: {{count}}",
    "imported_few": "Импортировано устройств: {{devices}}, показателей: {{count}}",
    "imported_many": "Импортировано устройств: {{devices}}, показателей: {{count}}",
    "imported_other": "Импортировано устройств: {{devices}}, показателей: {{count}}",
    "importMock": "Тестовый режим: устройства будут созданы, когда будет готов бэкенд",
    "type": "Тип сигнала"
  },
  "log": {
    "time": "Время",
    "level": "Уровень",
    "message": "Сообщение",
    "search": "Поиск по сообщению",
    "all": "Все",
    "empty": "Журнал пуст",
    "levels": {
      "info": "Инфо",
      "warning": "Предупреждение",
      "error": "Ошибка"
    },
    "codes": {
      "sync": {
        "ok": "Синхронизация завершена: датчиков {{sensors}}, {{ms}} мс"
      },
      "sensors": {
        "stale": "Датчиков без обновления более 3 часов: {{count}}",
        "imported": "Запрошен импорт: устройств {{devices}}, датчиков {{sensors}} (тестовый режим)"
      },
      "source": {
        "timeout": "Источник не ответил за {{ms}} мс",
        "retry": "Повтор через {{sec}} с"
      },
      "auth": {
        "failed": "Авторизация отклонена (HTTP {{status}})"
      },
      "test": {
        "ok": "Проверка подключения успешна: {{ms}} мс, датчиков {{sensors}}",
        "failed": "Проверка подключения не удалась: {{error}}"
      },
      "connector": {
        "created": "Коннектор создан",
        "updated": "Настройки изменены",
        "enabled": "Коннектор включён",
        "disabled": "Коннектор выключен"
      },
      "sensor": {
        "bound": "{{column}} → {{indicator}} привязан",
        "unbound": "{{column}} отвязан"
      }
    }
  },
  "settings": {
    "title": "Настройки подключения",
    "desc": "Адрес источника, учётные данные и интервал опроса",
    "orgOnly": "Это коннектор организации — изменить его может только администратор организации.",
    "readOnly": "Для изменения коннекторов нужно право редактирования модуля «Коннекторы»."
  }
}
